<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            fill?: `fill-${string}`;
            symbolOnly?: boolean;
            height?: `h-${string}`;
        }>(),
        {
            height: 'h-6',
            fill: 'fill-primary-beet',
            symbolOnly: false,
        }
    );
</script>

<template>
    <svg
        v-if="props.symbolOnly"
        viewBox="0 0 196.83 193.21"
        xmlns="http://www.w3.org/2000/svg"
        :class="props.height + ' w-auto max-w-full block'"
    >
        <g :class="props.fill">
            <path
                d="m68.78 182c-.49 6.33-5.77 11.21-12.11 11.21h-41.8c-6.42 0-11.73-4.99-12.13-11.4l-2.72-43.71c-.22-3.48 1.07-6.88 3.53-9.34l51.93-51.95c7.98-7.98 21.58-1.72 20.71 9.53l-7.42 95.66zm63.59-56.86c0-45.75 3.11-68.34-37.92-60.84-9.92 2.24-16.6-9.88-9.41-17.07l43.77-43.83c2.28-2.28 5.38-3.62 8.6-3.37 33.24 2.57 59.42 30.36 59.42 64.26v116.77c0 6.71-5.44 12.15-12.15 12.15h-40.16c-6.71 0-12.15-5.44-12.15-12.15v-55.93z"
            />
            <path
                d="m72.24 36.39c0-16.33-12.33-28-29.66-28s-29.66 11.66-29.66 28 13 28.33 29.66 28.33 29.66-12 29.66-28.33z"
            />
        </g>
    </svg>

    <svg
        v-else
        viewBox="0 0 1371.99 193.21"
        xmlns="http://www.w3.org/2000/svg"
        :class="props.height + ' w-auto max-w-full block'"
    >
        <g :class="props.fill">
            <path
                d="m68.78 182c-.49 6.33-5.77 11.21-12.11 11.21h-41.8c-6.42 0-11.73-4.99-12.13-11.4l-2.72-43.71c-.22-3.48 1.07-6.88 3.53-9.34l51.93-51.95c7.98-7.98 21.58-1.72 20.71 9.53l-7.42 95.66zm63.59-56.86c0-45.75 3.11-68.34-37.92-60.84-9.92 2.24-16.6-9.88-9.41-17.07l43.77-43.83c2.28-2.28 5.38-3.62 8.6-3.37 33.24 2.57 59.42 30.36 59.42 64.26v116.77c0 6.71-5.44 12.15-12.15 12.15h-40.16c-6.71 0-12.15-5.44-12.15-12.15v-55.93z"
            />
            <path
                d="m72.24 36.39c0-16.33-12.33-28-29.66-28s-29.66 11.66-29.66 28 13 28.33 29.66 28.33 29.66-12 29.66-28.33z"
            />
            <path
                d="m1332.47 167.18c-29.66 6.3-54.47-10.4-60.49-38.67-6.05-28.44 9.96-54 38.93-60.16 31.38-6.67 56.11 13.84 60.32 45.55l-72.76 15.46c4.78 14.84 16.73 20.22 29.49 17.51 9.48-2.02 16.84-8.08 18.51-16.36l25.52-5.42c-2.31 23.91-19.18 37.77-39.53 42.09zm-36.63-56.17 45.35-9.64c-4.96-9.76-14.22-15.17-26.12-12.65-12.07 2.56-18.29 11.45-19.23 22.28z"
            />
            <path
                d="m1220.43 67.33c20.62 0 33.49 14.27 33.49 37.71v61.33h-25.21v-55.86c0-12.34-4.58-19.21-16.75-19.21-13.22 0-20.1 8.81-20.1 24.14v50.93h-25.21v-55.86c0-12.34-4.58-19.21-16.75-19.21-13.22 0-20.27 8.81-20.27 24.14l.18 50.93h-25.38v-96.92h25.38v12.86c6.87-9.52 16.22-14.98 28.73-14.98 13.93 0 24.33 6.52 29.44 18.33 7.05-11.45 18.16-18.33 32.44-18.33z"
            />
            <path
                d="m995.93 167.18c-29.66 6.3-54.47-10.4-60.48-38.67-6.05-28.44 9.96-54 38.93-60.16 31.38-6.67 56.11 13.84 60.33 45.55l-72.76 15.46c4.78 14.84 16.73 20.22 29.5 17.51 9.48-2.02 16.84-8.08 18.51-16.36l25.52-5.42c-2.3 23.91-19.18 37.77-39.53 42.09zm-36.63-56.17 45.35-9.64c-4.96-9.76-14.22-15.17-26.12-12.65-12.07 2.56-18.29 11.45-19.23 22.28z"
            />
            <path
                d="m896.23 168.49c-19.39 0-36.31-11.63-36.31-39.47v-35.77h-17.28v-23.79h17.28v-20.97l25.21-5.46v26.43h35.96v23.79h-35.96v34.36c0 11.45 5.46 17.45 15.51 17.45 5.64 0 12.34-1.94 20.27-4.76l4.23 20.44c-5.29 3.52-17.27 7.75-28.91 7.75z"
            />
            <path
                d="m773.02 168.49c-25.38 0-44.25-20.79-44.25-50.58s19.21-50.58 44.07-50.58c13.75 0 23.97 6.34 30.67 15.68v-13.57h25.21l-.18 96.92h-25.21l.18-13.04c-6.88 9.16-16.92 15.16-30.5 15.16h.01zm5.64-23.97c14.1 0 24.86-10.57 24.86-26.61s-10.75-26.61-24.86-26.61-24.5 10.75-24.5 26.61 10.58 26.61 24.5 26.61z"
            />
            <path
                d="m677.1 167.19c-28.45 6.05-53.86-10.9-59.83-38.99-5.97-28.1 10.35-53.9 38.97-59.99 23.1-4.91 46.59 4.69 55.34 28.06l-25.35 5.39c-5.13-9.72-15.16-12.81-25.16-10.69-15 3.19-22.31 16.27-18.8 31.92 3.2 15.89 15.51 24.63 29.99 21.55 10.17-2.16 18.04-9.24 18.77-20.2l25.35-5.39c1.52 25.8-16.52 43.51-39.28 48.34z"
            />
            <path
                d="m573.04 166.38v-96.92h25.21v96.92zm12.69-141.69c9.17 0 15.69 6.17 15.69 14.8s-6.52 14.98-15.69 14.98-15.69-6.34-15.69-14.98 6.87-14.8 15.69-14.8z"
            />
            <path
                d="m497.28 168.49c-25.21 0-44.25-20.79-44.25-50.58s19.21-50.58 44.07-50.58c13.75 0 23.97 6.34 30.67 15.68v-52.34h25.21v135.69h-25.21v-13.04c-6.7 9.16-16.75 15.16-30.49 15.16zm5.64-23.96c14.1 0 24.85-10.57 24.85-26.61s-10.75-26.61-24.85-26.61-24.5 10.75-24.5 26.61 10.58 26.61 24.5 26.61z"
            />
            <path
                d="m344.26 166.37v-96.92h25.21v13.22c7.05-9.87 16.75-15.33 30.14-15.33 21.86 0 35.08 14.45 35.08 38.24v60.8h-25.21v-55.33c0-12.69-4.76-19.74-18.16-19.74-14.28 0-21.86 8.28-21.86 24.14v50.93h-25.21z"
            />
            <path
                d="m298.81 166.38v-96.92h25.21v96.92zm12.69-141.69c9.17 0 15.69 6.17 15.69 14.8s-6.52 14.98-15.69 14.98-15.69-6.34-15.69-14.98 6.87-14.8 15.69-14.8z"
            />
        </g>
    </svg>
</template>
